import { createActionGroup, props } from '@ngrx/store';
import { BaseOrderAction } from './order.action';
import { OfflineIpoCreateRequest, OfflineIpoUpdateRequest } from '@easy-lib/modules/offline-ipo';

export const OfflineAction = createActionGroup({
	source: 'offline',
	events: {
		...BaseOrderAction,
		createOffline: props<{ value: OfflineIpoCreateRequest }>(),
		updateOffline: props<{ value: OfflineIpoUpdateRequest }>(),
		deleteOffline: props<{ id: string }>(),
		deletedOffline: props<{ id: string }>() //effect
	}
});
